/* Zen Routine — Affiliate page helpers. Loaded once, defer. */
(function () {
  if (window.__zrAffiliateInit) return;
  window.__zrAffiliateInit = true;

  /* ---- Scroll reveal ---- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.zr-reveal:not([data-zr-seen])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var delay = parseInt(el.getAttribute('data-zr-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { el.setAttribute('data-zr-seen', '1'); io.observe(el); });
  }

  /* ---- Sticky apply bar: hide while the form section is on screen ---- */
  function initSticky() {
    var bar = document.querySelector('[data-zr-sticky]');
    if (!bar) return;
    var targetId = bar.getAttribute('data-zr-sticky-hide-at');
    var showAfter = parseInt(bar.getAttribute('data-zr-sticky-after') || '400', 10);
    var target = targetId ? document.getElementById(targetId) : null;
    var overForm = false;

    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        overForm = entries[0].isIntersecting;
        update();
      }, { threshold: 0.08 }).observe(target);
    }
    function update() {
      var past = window.scrollY > showAfter;
      bar.classList.toggle('is-visible', past && !overForm);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---- Count-up on stat numbers ---- */
  function initCounters() {
    var nodes = document.querySelectorAll('[data-zr-count]');
    if (!nodes.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var to = parseFloat(el.getAttribute('data-zr-count'));
        if (isNaN(to)) return;
        var pre = el.getAttribute('data-zr-prefix') || '';
        var post = el.getAttribute('data-zr-suffix') || '';
        var start = null, dur = 1100;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + Math.round(to * eased).toLocaleString() + post;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nodes.forEach(function (n) { io.observe(n); });
  }

  function boot() { initReveal(); initSticky(); initCounters(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  /* Theme editor: re-run when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initSticky(); initCounters(); });
})();
